import styled from 'styled-components/macro';

export const Main = styled.main<{ pad?: 'small' | 'large'}>`
    padding: 64px ${props => props.pad === 'small' ? '20px' : '20%'} 10px;
`;